import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../static/styles/RedeemForm.module.css';
import MessagePopup from '../components/MessagePopup';
import { completeRedemption } from '../api/rewards';
import { isAuthenticated } from '../api/auth';
import { trackRewardRedemptionSuccess } from '../utils/analytics';
import ArrowLeft from '../static/img/backArrow.png'

const RedeemForm = ({ reward }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [pubgId, setPubgId] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState({});
    const [popupMessage, setPopupMessage] = useState("");
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const ucredits = location.state.ucredits;
    const leftCreds = location.state.leftCreds;
    console.log(ucredits, leftCreds)
    useEffect(() => {
        document.title = "Redeem Form | Jazz ESL";
        if (!isAuthenticated()) {
            window.location.href = process.env.REACT_APP_LOGIN_URL;
        }
        if (!location.state) {
            navigate('/rewards');
            return;
        }

        setName(sessionStorage.getItem('username') || '')
    }, []);

    const handleRedemption = () => {
        if (isSubmitting) {
            return;
        }

        const isIdRequired = location.state?.reward?.is_id_required;
        const isPubgIdValid = !isIdRequired || (pubgId && pubgId.length >= 9 && pubgId.length <= 13 && /^\d+$/.test(pubgId));
        const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        // const isFormValid = name && email && isPubgIdValid;
        const isFormValid = name && email && isEmailValid && isPubgIdValid;

        if (isFormValid) {
            setIsSubmitting(true);

            const rawMsisdn = sessionStorage.getItem('msisdn') || '';
            const phone = rawMsisdn.startsWith('92') ? rawMsisdn : `92${rawMsisdn.replace(/^0/, '')}`;
            const cleanName = name.trim();
            const cleanEmail = email.trim();
            const data = {
                item: location.state.reward.id,
                uuid: location.state.reward.uuid,
                name: cleanName,
                email: cleanEmail,
                phone,
            };

            if (isIdRequired) {
                data.pubgId = pubgId;
            }

            completeRedemption(data)
                .then(response => {
                    if (response.status === 200) {
                        if (response.data.success) {
                            trackRewardRedemptionSuccess(
                                location.state.gtagItemName,
                                location.state.reward.id,
                                location.state.reward.credits || 0
                            );
                            navigate('/thankyou', {
                                state: {
                                    reward: location.state.reward,
                                    gameId: pubgId,
                                    phone: phone,
                                    email: cleanEmail,
                                    name: cleanName
                                }
                            })
                        } else {
                            const errorMessage = response.data?.data?.message || "Redemption failed. Please try again.";
                            setPopupMessage(errorMessage);
                            setIsPopupOpen(true);
                            setIsSubmitting(false);
                        }
                    } else {
                        setPopupMessage("Redemption failed. Please try again.");
                        setIsPopupOpen(true);
                        setIsSubmitting(false);
                    }
                })
                .catch(error => {
                    setPopupMessage("An error occurred. Please try again.");
                    setIsPopupOpen(true);
                    setIsSubmitting(false);
                });
        }
        else {
            const isIdRequired = location.state?.reward?.is_id_required;

            if (!name || !email) {
                setPopupMessage("Please fill in all required fields.");
            }
            else if (!isEmailValid) {
                setPopupMessage("Please enter a valid email address.");
            }
            else if (isIdRequired && !pubgId) {
                setPopupMessage("Please fill in PUBG ID.");
            }
            else if (isIdRequired && (pubgId.length < 9 || pubgId.length > 13 || !/^\d+$/.test(pubgId))) {
                setPopupMessage("PUBG ID must be 9-13 digits and contain only numbers.");
            }
            else {
                setPopupMessage("Please check your inputs.");
            }

            setIsPopupOpen(true);
        }
    }

    return (
        <div className={styles.container}>

            {/* HEADER */}
            <div className={styles.navigationHeader}>
                <div
                    className={styles.navigationBack}
                    onClick={() => navigate(-1)}
                >
                    <img src={ArrowLeft} alt="<" />
                </div>
                <div className={styles.navigationTitle}>
                    <p>Step 1 of 2</p>
                    <h2 className={styles.heading}>redeem reward</h2>
                </div>
            </div>

            {/* REWARD CARD */}
            <div className={styles.rewardCard}>
                <div className={styles.rewardLeft}>
                    <div className={styles.rewardIcon}>
                        {/* PUBG<br />300 UC */}
                        <img
                            src={location.state.rImg}
                            alt=""
                            className={styles.rewardImage} />
                    </div>
                </div>

                <div className={styles.rewardInfo}>
                    <span className={styles.badge}>POPULAR</span>
                    <h3>{location.state?.reward?.name}</h3>
                </div>

                <div className={styles.price}>
                    🪙 {location.state?.reward?.credits}
                </div>
            </div>

            {/* ACCOUNT DETAILS */}
            <div className={styles.section}>
                <span className={styles.sectionLabel}>ACCOUNT DETAILS</span>

                {/* NAME */}
                <div className={styles.inputGroup}>
                    <label>NAME</label>
                    <input
                        value={name}
                        onChange={e => setName(e.target.value.replace(/[^a-zA-Z0-9\s]/g, ''))}
                        placeholder="Enter your name"
                        required
                        minLength={3}
                        maxLength={50}
                    />
                </div>

                {/* EMAIL */}
                <div className={styles.inputGroup}>
                    <label>EMAIL</label>
                    <input
                        type="email"
                        value={email}
                        onChange={e => setEmail(e.target.value.trim())}
                        placeholder="Enter email address"
                        required
                        maxLength={100}
                        pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    />
                </div>

                {/* PUBG ID */}
                {location.state?.reward?.is_id_required && (
                    <>
                        <div className={styles.inputGroup}>
                            <label>PUBG ID</label>
                            <input
                                type="text"
                                value={pubgId}
                                onChange={e => setPubgId(e.target.value.replace(/[^0-9]/g, ''))}
                                placeholder="e.g. 5847296301"
                                minLength={9}
                                maxLength={13}
                                required
                            />
                            <small>Find this in PUBG Mobile → Profile → Basic Info</small>
                        </div>

                        {/* <div className={styles.inputGroup}>
                            <label>CONFIRM PUBG ID</label>
                            <input
                                type="text"
                                placeholder="Re-enter your PUBG ID"
                                minLength={9}
                                maxLength={13}
                                required
                            />
                        </div> */}
                    </>
                )}

                {/* PHONE */}
                <div className={styles.inputGroup}>
                    <label>CONTACT NUMBER</label>
                    <input
                        value={sessionStorage.getItem('msisdn') || ''}
                        readOnly
                    />
                    <small>We will SMS your code here</small>
                </div>
            </div>

            {/* WALLET */}
            <div className={styles.walletCard}>
                <div>
                    <span>WALLET BALANCE</span>
                    <h3>{ucredits} credits</h3>
                </div>

                <div className={styles.afterRedeem}>
                    <span>AFTER REDEEM</span>
                    <br />
                    <strong>{leftCreds} credits</strong>
                </div>
            </div>

            {/* CTA */}
            <button
                className={styles.ctaBtn}
                onClick={handleRedemption}
                disabled={isSubmitting}
            >
                {isSubmitting ? 'PROCESSING...' : 'CONTINUE TO CONFIRM →'}
            </button>

            <p className={styles.note}>
                Delivery in {location.state?.reward?.game === null ? 'Within 7 days' : '24–48 hours'} · Auto-refund if undeliverable
            </p>

            <MessagePopup
                isOpen={isPopupOpen}
                message={popupMessage}
                onClose={() => setIsPopupOpen(false)}
            />

        </div>
    );
};

export default RedeemForm;